module.exports = __webpack_public_path__ + "img/Maßnahme.5942ec45.svg";